import ResultView from './views/ResultView';

export default function Result() {
    return (
        <>
            <ResultView />
        </>
    );
}
